// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9330447b","579":"37d4701f"}[chunkId] + ".chunk.js";
};